<template lang="pug">
  div.refine-search-wrapper
    div.keywords 根据关键词
      a “{{keywords}}”,
      | 搜索到xx条信息 / 在**
    div.refine-search
      header
        div.name 筛选
        div.condition 1~3 items
      section
        div.refine
          span refine (0)
          i.fa.fa-plus
        div.sort
          form(action="")
            select
              option(selected) Sort
              option Value 1
              option Value 2
          i.fa.fa-caret-down
    section.category
      h3 RefineSearch
      div.category category
    section.filter
      h3 FILTERS
      ItemOption(v-for="(item, $index) in filter",
                 :key="$index",
                 :item="item",
                 :toggle="toggleFilterOptionFold",
                 :doSelectFilter="selectFilter")
</template>
<script>
import ItemOption from './ItemOption'
export default {
  name: 'RefineSearch',
  props: ['keywords', 'category', 'filter', 'toggleFilterOptionFold', 'toggleCategoryOptionFold', 'selectCategory', 'selectFilter'],
  methods: {
  },
  components: {
    ItemOption
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/common.scss";

.keywords {
  color: $lightGrayColor;
  padding: 1.25rem 0.9375rem;
  border-bottom: 1px solid $borderColor;
  font-size: 16px;
  font-size: 1rem;
  font-family: akzidenz-grotesk-condensed,Arial Narrow,Arial,sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1em;
  margin-bottom: 1.875rem;
    a {
      color: $lightBlue;
    }
}

section {
  padding:  0 10px;
}
.refine-search {
    font-size: 13px;
    font-size: .8125rem;
    width: 100%;
    padding: 1.25rem 10px;
      header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
      }
      .name {
        font-size: 18px;
        font-size: 1.125rem;
      }
      .condition {
        font-family: akzidenz-grotesk,Arial,sans-serif;
        font-weight: 400;
        font-size: 12px;
        font-size: .75rem;
        color: #7b7b82;
        text-transform: none;
        letter-spacing: normal;
        line-height: 26px;
        line-height: 1.625rem;
      }
      section {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
      }
      .refine,
      .sort {
        border: 1px solid $borderColor;
        height: 2.5rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
      }
      .refine {
        flex: 1;
        margin-right: 10px;
      }

      .sort {
        flex: 1;
        align-self: stretch;
        width: 100%;
        form {
          flex: 1;
          height: 100%;;
        }
        select {
          width: 100%;
          border:none;
          outline: none;
          height: 100%;
          background: transparent;
        }
      }

}
</style>
